import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { StorageService } from './storage.service';

export interface PlanElegido {
  id: number;
  slug: string;
  nombre: string;
  precio: number;
}

const CLAVE = 'codeland_origen';
const ENVIADO = 'codeland_origen_enviado';
const CAMPOS = ['utm_source', 'utm_medium', 'utm_campaign', 'ref', 'plan'] as const;

/**
 * De dónde vino el que se registra (campaña, referido) y qué plan eligió en la página
 * de planes. Se junta de la URL en el primer ingreso al sitio y se manda una sola vez,
 * ya con la cuenta creada: así vale igual para el registro con mail y con Google.
 *
 * Nada de esto puede romper la navegación: todo va entre try/catch.
 */
@Injectable({ providedIn: 'root' })
export class OrigenService {
  constructor(private api: ApiService, private storage: StorageService) {}

  /** Lee la URL de entrada. Vale el primer contacto; el plan sí se actualiza si elige otro. */
  capturar(): void {
    try {
      const params = new URLSearchParams(window.location.search);
      const guardado = this.leer();
      const nuevo: Record<string, string> = { ...guardado };

      for (const campo of CAMPOS) {
        const valor = params.get(campo)?.trim().slice(0, 80);
        if (valor && (campo === 'plan' || !guardado[campo])) {
          nuevo[campo] = valor;
        }
      }
      if (!guardado['landing']) {
        nuevo['landing'] = window.location.pathname.slice(0, 200);
      }

      if (JSON.stringify(nuevo) !== JSON.stringify(guardado)) {
        localStorage.setItem(CLAVE, JSON.stringify(nuevo));
        localStorage.removeItem(ENVIADO);
      }
    } catch {
      // Sin almacenamiento no se mide el origen; el registro funciona igual.
    }
  }

  /** Con la sesión del dueño abierta, manda lo juntado (una vez). */
  enviar(): void {
    try {
      const origen = this.leer();
      const hayAlgo = CAMPOS.some(campo => !!origen[campo]);
      if (!hayAlgo || !this.storage.getToken() || localStorage.getItem(ENVIADO)) {
        return;
      }

      localStorage.setItem(ENVIADO, '1');
      this.api.post('/owner/origen', origen).subscribe({
        error: () => localStorage.removeItem(ENVIADO),
      });
    } catch {
      // Ídem.
    }
  }

  private leer(): Record<string, string> {
    try {
      return JSON.parse(localStorage.getItem(CLAVE) || '{}') ?? {};
    } catch {
      return {};
    }
  }
}
